<template>
  <div class="image-upload">
    <input
      id="file-input"
      type="file"
      name="name"
      style="display: none;"
      accept=".jpg,.png,.pdf,.dwg,.psd,.xlsx"
      multiple="false"
      @click="function (event) {event.target.value = null}"
      @change="handleFiles"
    >
    <div
      class="select-files"
      @mouseup="handleSelect"
    >
      UPLOAD FILES
    </div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { useResourceStore } from '@/store/ResourceStore';

export default {
  name: 'ImageUpload',
  setup () {
    const RMTStore = useRMTStore();
    const resourceStore = useResourceStore();
    return {
      RMTStore, resourceStore
    };
  },
  data () {
    return {
      fileUploads: [],
    };
  } ,
  mounted () {
/*    this.RMTStore.fetchLibraryTypes();
    this.RMTStore.fetchLibraryCategories();*/
  },
  methods: {
    handleSelect () {

      document.getElementById('file-input').click();

    },
    handleFiles (event) {
      this.RMTStore.inUploadMode = true;

      this.RMTStore.clearSelectedUploads();
      this.RMTStore.clearSelectedResources();
      this.RMTStore.setPanelIsHidden(false);
      this.RMTStore.clearAssociations();


      this.RMTStore.filterUploadResources.forEach((resource) => {
          URL.revokeObjectURL(resource.imageUri);
      });

      this.resourceStore.filterUploadResources = [];

      event.target.files.forEach((element, index) => {
        element.imageUrl = URL.createObjectURL(element);
        this.RMTStore.filterUploadResources.push({
          fileBlob:  element,
          imageUri: element.imageUrl,
          file: element.name,
          resourceUri: element.name, // element.name.split('.').slice(0, -1).join('.'),
          name: element.name,
          description: '',
          alt: '',
          date: '',
          size: element.size,
          type: element.type,
          id: index,
          tagIds: [],
          collections: [],
          permissions: [],
          /* todo: permissions will be subscriptions in a string array DELETE permissions */
          subscription: '',
          isSelected: false,
          libCategoryId: 0,
          libTypeId: 0
        });
      });
      this.RMTStore.data = this.getDefaultData;

      this.RMTStore.uploads[0].isSelected = true;
      this.RMTStore.setSelectedItemNum(0);

      this.RMTStore.inMultiSelectionMode = false;


    },
  }
};
</script>

<style scoped>
.image-upload {
  display: flex;
  justify-content: space-between;
  height: 30px;
}
.select-files {
  cursor: pointer;
  background-color: #72b9f3;
  color: white;
  width: 160px;
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: .8em;
  font-weight: 900;
  letter-spacing: .07em;
  transition: background-color .2s;
}
.select-files:hover {
  background-color: #58a0da;
}
</style>